/* unplugin-vue-components disabled */import { render } from "./CampaignReport.vue?vue&type=template&id=58f1fb1a"
import script from "./CampaignReport.vue?vue&type=script&lang=js"
export * from "./CampaignReport.vue?vue&type=script&lang=js"

import exportComponent from "/myfunnl/isspadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__